import script from "./activate-brand(s).vue?vue&type=script&setup=true&lang=js"
export * from "./activate-brand(s).vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__